import { Controller } from "@hotwired/stimulus"

// Cascading hub → section select for hub classification review.
// When the hub dropdown changes, shows only the sections belonging to that hub.
export default class extends Controller {
  static targets = ["hubSelect", "sectionSelect", "approveButton"]

  connect() {
    this._buildSectionIndex()
    this._updateSections()
  }

  hubChanged() {
    this._updateSections()
  }

  _buildSectionIndex() {
    this._allOptions = Array.from(this.sectionSelectTarget.options).slice(1).map(opt => ({
      value: opt.value,
      text: opt.text,
      hubId: opt.dataset.hubId
    }))
  }

  _updateSections() {
    const hubId = this.hubSelectTarget.value
    const select = this.sectionSelectTarget

    // Remove all non-placeholder options
    while (select.options.length > 1) select.remove(1)

    if (!hubId) {
      select.disabled = true
      this.approveButtonTarget.disabled = true
      return
    }

    const matching = this._allOptions.filter(o => o.hubId === hubId)
    matching.forEach(o => {
      const opt = new Option(o.text, o.value)
      select.add(opt)
    })

    select.disabled = matching.length === 0
    this.approveButtonTarget.disabled = false
  }
}
